import { APIDataDepartmentAgreement, APIMetaDataDepartmentAgreementPropertyNames, Store } from '@evertel/types'
import { decorate, injectable } from '@evertel/di'

class DepartmentAgreementStore extends Store<APIDataDepartmentAgreement> {
    constructor() {
        super([...APIMetaDataDepartmentAgreementPropertyNames, 'currentDocument'])
    }
}

decorate(injectable(), DepartmentAgreementStore)

export { DepartmentAgreementStore }
